export function normalizeInteger(value, fallback, options = {}) {
    const { min = 1 } = options;
    const parsed = Number.parseInt(value, 10);

    return Number.isNaN(parsed) || parsed < min ? fallback : parsed;
}

export function normalizeNumericValue(value) {
    const normalized = Number.parseFloat(value);
    return Number.isFinite(normalized) ? Math.round(normalized) : 0;
}

export function normalizeString(value) {
    return String(value || '').trim();
}

export function normalizeStringOrNull(value) {
    const normalizedValue = normalizeString(value);

    return normalizedValue || null;
}

export function normalizeLowercaseString(value) {
    return normalizeString(value).toLowerCase();
}

export function normalizeStringArray(value) {
    return Array.from(
        new Set(
            (Array.isArray(value) ? value : [value])
                .map((item) => normalizeString(item))
                .filter(Boolean),
        ),
    );
}

export function normalizeArrayLike(value, normalizer) {
    const values = Array.isArray(value)
        ? value
        : typeof value === 'string'
            ? value.split(',')
            : [];

    return values
        .map((item, index) => normalizer(item, index))
        .filter(Boolean);
}

export function normalizeFirstString(value, fields = []) {
    for (const field of fields) {
        const normalized = normalizeStringOrNull(value?.[field]);

        if (normalized) {
            return normalized;
        }
    }

    return null;
}

export function isRecord(value) {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}
